import React from "react";
import { useIntl } from "react-intl";
import { Form, Button, Input } from "reactstrap";

function WeatherForm({
  getWeatherUpdate
}: {
  getWeatherUpdate: (e: React.FormEvent<HTMLFormElement>) => void | Promise<void>;
}) {
  const { formatMessage } = useIntl();

  return (
    <div>
      <Form onSubmit={getWeatherUpdate}>
        <Input
          className="mr-2 mb-2 mx-auto"
          type="text"
          name="city"
          placeholder={formatMessage({ id: "main.city-name" })}
        />
        <Input
          type="text"
          name="country"
          placeholder={formatMessage({ id: "main.country-name" })}
          className="mr-2 mb-2 mx-auto"
        />
        <Button className="bg-theme-1 mx-auto">
          {" "}
          {formatMessage({ id: "main.get-weather-update" })}
        </Button>
      </Form>
    </div>
  );
}

export default WeatherForm;
